exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".org-content .content {\n  min-height: 130px; }\n  .org-content .content p {\n    margin: 0px;\n    padding: 0px;\n    font-size: 12px; }\n\n.org-content .subfooter {\n  padding-top: 10px; }\n  .org-content .subfooter div {\n    border-top: 1px solid #eee;\n    width: 30%;\n    padding-top: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/compute/compute-vcd/organization/organization.scss
// module id = hDP9
// module chunks = 0